import { AuthenticationType, Map } from 'azure-maps-control';
import { getClient } from '@/common/apis/client-helper';
import { SasToken, SasTokenResult } from '@/common/constants/map-display-types';

type AzureMapOptions = ConstructorParameters<typeof Map>[1];

const mapTokenKey = 'mapToken';

export function getMapOptions(): AzureMapOptions {
  const sasToken = localStorage.getItem(mapTokenKey) as string | undefined;

  return {
    language: navigator.language || window.navigator.language,
    style: 'light',
    showLogo: false,
    zoom: 2,
    view: 'Auto',
    showFeedbackLink: false,
    disableTelemetry: true,
    scrollZoomInteraction: false,
    boxZoomInteraction: false,
    dragRotateInteraction: false,
    authOptions: {
      authType: AuthenticationType.sas,
      sasToken,
      getToken(resolve) {
        getSasToken()
          .then((response) => {
            response.token && localStorage.setItem(mapTokenKey, response.token);
            resolve(response.token);
          });
      }
    }
  };
}

export async function getSasToken(): Promise<SasToken> {
  const { gatewayApiUri, authToken } = await getClient();
  const response = await fetch(`${gatewayApiUri}/azuremaps/token`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}` }
  });
  const data: SasTokenResult = await response.json();
  return data.sasToken ?? {};
}
